export default {
  list: { lazy: () => import('./ApiRequestLogList') },
  options: {
    list: {
      title: 'API Access Logs',
      breadCrumb: 'API Access Logs',
    },
  },
}
